var React = require('react');

function Save (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","d":"M1 1v21.054l7.76-5.557 7.24 5.49V1H1z"}));
}

Save.displayName = "Save";

Save.defaultProps = {"viewBox":"0 0 17 24"};

module.exports = Save;

Save.default = Save;
